import { UserProfileService } from './services/userProfile.service';
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IdentityService } from "./services/identity.service";
import { EmergencyService } from "./services/emergency.service";
import { VehicleService } from "./services/vehicle.service";
import { PersonalDocService } from './services/personalDoc.service';
import { GlobalService } from './services/Global.service';
import { AddressService } from './services/address.service';
import { MeetingService } from './services/meeting.service';
import { CityService } from './services/city.service';
import { TripService } from './services/trip.service';
import { MotoclubService } from './services/motoclub.service';
import { SyshealthService } from './services/Syshealth.service';
import { AppauthService } from './services/appauth.service';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule
  ],
  exports:[
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule
  ],

  providers:[
    IdentityService,
    EmergencyService,
    VehicleService,
    UserProfileService,
    PersonalDocService,
    GlobalService,
    AddressService,
    MeetingService,
    CityService,
    TripService,
    MotoclubService,
    SyshealthService,
    AppauthService
  ]
})
export class CoreModule { }
